export default {
  computed: {
    currentPage () {
      return this.$route.name
    }
  },
  methods: {
    navigateTo (destination) {
      if (this.$route.name !== destination) {
        this.$router.push({ name: destination })
      }
    },
    goToURL (destination, target = '_blank') {
      window.open(destination, target)
    },
    logClick () {
      console.log('You click button')
    }
  }

}
